import { render } from "./ContactsPage.vue?vue&type=template&id=f832bae4&scoped=true"
import script from "./ContactsPage.vue?vue&type=script&lang=js"
export * from "./ContactsPage.vue?vue&type=script&lang=js"

import "./ContactsPage.vue?vue&type=style&index=0&id=f832bae4&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/freelance/naks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f832bae4"]])

export default __exports__